import './ConfirmationDialog.css';
import '../Dialogs.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

export default function ConfirmationDialog({ show, title, text, yesClickedCallback, noClickedCallback }) {
    return (
        <div className={"modal-background " + (show ? "show" : "hide")}>
            <div className="modal-content">
                <div className="modal-content-grid">
                    <div className="modal-content-icon">
                        <FontAwesomeIcon icon={faTriangleExclamation} />
                    </div>
                    <div className="modal-content-wrapper">
                        <div className="modal-title">
                            {title}
                        </div>
                        <div className="modal-body">
                            {text}
                        </div>
                    </div>
                </div>
                <div className="confirmation-dialog-controls">
                <button className="green" onClick={yesClickedCallback}><FontAwesomeIcon icon={faCircleCheck} /></button>
                    <button className="red" onClick={noClickedCallback}><FontAwesomeIcon icon={faCircleXmark} /></button>
                </div>
            </div>
        </div>
    )
}